import { Button, DatePicker, Image, Input, Modal, Select } from 'antd'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import CountriesDropdown from '../CountriesDropdown'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import Loader from '../../pages/pages/loader'
import { getUserId } from '../../helpers/auth'
import {
  useAddCustomerMutation,
  useUpdateCustomerMutation
} from '../../redux/apis/customersManagement/customers/cMcustomerApiSlice'

const EditCreateCustomer = ({ state, open, setOpen, record }) => {
  const [
    updateCustomer,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateCustomerMutation()
  const [
    addCustomer,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useAddCustomerMutation()

  const [file, setFile] = useState(null)
  const [preview, setPreview] = useState('')
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      customer_name: record?.customer_name || '',
      customer_business: record?.customer_business || '',
      customer_phone: record?.customer_phone || '',
      customer_address: record?.customer_address || '',
      customer_reporting_abuse_to: record?.customer_reporting_abuse_to || 'ISP',
      customer_abuse_email: record?.customer_abuse_email || '',
      customer_abuse_form: record?.customer_abuse_form || '',
      contract_end_date: record?.contract_end_date || '',
      contract_start_date: record?.contract_start_date || '',
      country: record?.country?.id || '',
      profile_image: record?.profile_image || "",
      user: getUserId()
    },

    validationSchema: Yup.object({
      customer_name: Yup.string().required('Please Enter Customer Name'),
      customer_business: Yup.string().required(
        'Please Enter Customer Business'
      ),
      customer_phone: Yup.string().nullable(),
      customer_address: Yup.string().nullable(),
      customer_reporting_abuse_to: Yup.string().required(
        'Please Enter Reporting Abuse to'
      ),
      country: Yup.string().required('Please Choose Country'),
      customer_abuse_email: Yup.string().nullable(),
      customer_abuse_form: Yup.string().nullable()
    }),
    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        if (state === 'edit' && key === 'user') continue
        formData.append(key, values[key])
      }

      if (file) {
        formData.append('profile_image', file)
      }
      try {
        if (state === 'edit') {
          await updateCustomer({ body: formData, id: record?.id }).unwrap()
        } else if (state === 'create') {
          await addCustomer(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('Customer created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('Customer updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])

  useEffect(() => {
    if (!file) {
      return
    }

    const objectUrl = URL.createObjectURL(file)
    setPreview(objectUrl)
    return () => URL.revokeObjectURL(objectUrl)
  }, [file])

  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? 'Edit Customer' : 'Create Customer'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />
      <div className=' mb-3'>
        <label className="form-label">Customer Name</label>
        <Input
          type='text'
          name='customer_name'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.customer_name}
        />
        {validation.touched.customer_name && validation.errors.customer_name ? (
          <p className='text-danger'>{validation.errors.customer_name}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Customer Business</label>
        <Input
          type='text'
          name='customer_business'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.customer_business}
        />
        {validation.touched.customer_business &&
        validation.errors.customer_business ? (
          <p className='text-danger'>{validation.errors.customer_business}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Customer Contact Number</label>
        <Input
          type='text'
          name='customer_phone'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.customer_phone}
        />
        {validation.touched.customer_phone &&
        validation.errors.customer_phone ? (
          <p className='text-danger'>{validation.errors.customer_phone}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Customer Address</label>
        <Input
          type='text'
          name='customer_address'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.customer_address}
        />
        {validation.touched.customer_address &&
        validation.errors.customer_address ? (
          <p className='text-danger'>{validation.errors.customer_address}</p>
        ) : null}
      </div>
      <div>
        <CountriesDropdown
          onChange={e => validation.setFieldValue('country', e)}
          onBlur={validation.handleBlur}
          value={validation.values.country}
          validation={validation}
        />
        {validation.touched.country && validation.errors.country ? (
          <p className='text-danger'>{validation.errors.country}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Report Abuse To</label>
        <br />
        <Select
          name='customer_reporting_abuse_to'
          style={{
            width: '100%'
          }}
          value={validation.values.customer_reporting_abuse_to}
          onChange={e =>
            validation.setFieldValue('customer_reporting_abuse_to', e)
          }
          onBlur={validation.handleBlur}
          options={[
            { label: 'ISP', value: 'ISP' },
            { label: 'Customer', value: 'Customer' }
          ]}
        />
      </div>
      <div className=' mb-3'>
        <label className="form-label">Customer abuse reporting mail</label>
        <Input
          type='text'
          name='customer_abuse_email'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.customer_abuse_email}
        />
        {validation.touched.customer_abuse_email &&
        validation.errors.customer_abuse_email ? (
          <p className='text-danger'>
            {validation.errors.customer_abuse_email}
          </p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Customer abuse reporting form</label>
        <Input
          type='text'
          name='customer_abuse_form'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.customer_abuse_form}
        />
        {validation.touched.customer_abuse_form &&
        validation.errors.customer_abuse_form ? (
          <p className='text-danger'>{validation.errors.customer_abuse_form}</p>
        ) : null}
      </div>
      <div className=' mb-3 '>
        <label className="form-label">Contract Start Date</label>
        <br />
        <DatePicker
          style={{ width: '100%' }}
          name='contract_start_date'
          onChange={(e, date) =>
            validation.setFieldValue('contract_start_date', date)
          }
          onBlur={validation.handleBlur}
          value={
            validation.values.contract_start_date
              ? dayjs(validation.values.contract_start_date)
              : ''
          }
        />
        {validation.touched.contract_start_date &&
        validation.errors.contract_start_date ? (
          <p className='text-danger'>{validation.errors.contract_start_date}</p>
        ) : null}
      </div>
      <div className=' mb-3 '>
        <label className="form-label">Contract End Date</label>
        <br />
        <DatePicker
          style={{ width: '100%' }}
          name='contract_end_date'
          onChange={(e, date) =>
            validation.setFieldValue('contract_end_date', date)
          }
          onBlur={validation.handleBlur}
          value={
            validation.values.contract_end_date
              ? dayjs(validation.values.contract_end_date)
              : ''
          }
        />
        {validation.touched.contract_end_date &&
        validation.errors.contract_end_date ? (
          <p className='text-danger'>{validation.errors.contract_end_date}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Upload Profile Picture</label>
        <div className='flex gap-4 customInput'>
          <Input
            type='file'
            onChange={e => setFile(e.target.files[0])}
            accept='.png, .jpg, .jpeg'
            onBlur={validation.handleBlur}
            required
            style={{ height: '40px' }}
          />
          <Image
            className='border-1'
            style={{ width: '200px' }}
            src={preview ? preview : validation?.values?.profile_image}
          />
        </div>
        {validation.touched.media && validation.errors.media ? (
          <p className='text-danger'>{validation.errors.media}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditCreateCustomer
